// NANPA 555-0100–0199, in 100 fixed geographic US NPAs (2026-11-04 report).
// Edge source of truth; packages/types/src/dev-customer.ts is its byte-for-byte web twin.
// Keep this exact class in sync with atlas_sales.is_dev_phone. No toll-free NPAs.
export const DEV_GEOGRAPHIC_NPAS = [
  201, 202, 203, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 223,
  224, 225, 227, 228, 229, 231, 234, 235, 239, 240, 248, 251, 252, 253, 254, 256, 260, 262, 267,
  269, 270, 272, 274, 276, 279, 281, 283, 301, 302, 303, 304, 305, 307, 308, 309, 310, 312, 313,
  314, 315, 316, 317, 318, 319, 320, 321, 323, 324, 325, 326, 327, 329, 330, 331, 332, 334, 336,
  337, 339, 340, 341, 346, 347, 350, 351, 352, 353, 357, 360, 361, 363, 364, 369, 380, 385, 386,
  401, 402, 404, 405, 406,
] as const;
const geographicNpas: ReadonlySet<number> = new Set(DEV_GEOGRAPHIC_NPAS);
export function isDevPhone(phone: string | null | undefined): boolean {
  const digits = (phone ?? '')
    .trim()
    .replace(/^00/, '')
    .replace(/[^0-9]/g, '');
  return (
    /^1[2-9][0-9]{2}55501[0-9]{2}$/.test(digits) && geographicNpas.has(Number(digits.slice(1, 4)))
  );
}
export function isDevCustomer(
  name: string | null | undefined,
  phone: string | null | undefined,
): boolean {
  return Boolean(name?.startsWith('DEV - ') && isDevPhone(phone));
}
